// eslint-disable-next-line import/no-cycle
import { Country } from './index';

// eslint-disable-next-line no-shadow
export enum PhoneRequestStatus {
  REQUESTED = 'REQUESTED',
  OBTAINED = 'OBTAINED',
}

// eslint-disable-next-line no-shadow
export enum UsernameRequestStatus {
  NO_USERNAME = 'NO_USERNAME',
  APPROVED = 'APPROVED',
  IN_REVIEW = 'IN_REVIEW',
  RESERVED = 'RESERVED',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

export type AttributeType = 'LARGE_TEXT' | 'SHORT_TEXT' | 'NUMERIC' | 'LIST';

export type ContactAttribute = {
  attrId: number;
  name: string;
  value: string | null;
};

export type ContactAttributeAugmented = {
  id: number;
  name: string;
  type: AttributeType;
  activated: boolean;
  required: boolean;
  inPrechat: boolean;
  order: number;
  possibleValues: string[];
  list: boolean;
  numeric: boolean;
  shortText: boolean;
  largeText: boolean;
};

export type GeneralContactInfo = {
  id: number;
  botId: number;
  fullName: string;
  identificationNumber: string;
  email: string;
  phoneNumber: string;
  mobileNumber: string;
  country: Country;
  cityName: string;
  address: string;
  company: string;
  waUsername?: string;
  waUserId?: string;
  waPhoneRequestStatus?: PhoneRequestStatus;
  attributes: ContactAttribute[];
  attributesAugmented: ContactAttributeAugmented[];
};

export type ContactInfo = {
  id: number;
  fullName: string;
  identificationNumber: string;
  email: string;
  phoneNumber: string;
  mobileNumber: string;
  bsuid?: string;
  whatsappUsername?: string;
  phoneRequestStatus?: PhoneRequestStatus;
  country?: {
    isoCode: string;
    name: string;
    languageCode: string;
  };
  province?: {
    id: number;
    code: string;
    name: string;
    country: {
      isoCode: string;
      name: string;
      languageCode: string;
    };
  };
  city: string;
  cityName: string;
  address: string;
  company: string;
  remarks: null;
  isNewContact: boolean;
  lastUpdate: number;
  createAt: number;
  habeasdata: boolean;
  fullTextHabeasData?: string;
  channel: null;
  attributes: {
    attrId: number;
    name: string;
    value: string;
  }[];
  blacklisted: boolean;
  totalCount: number;
};
